import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import {auto} from "react-recaptcha/.yarn-cache/v1/npm-async-2.4.1-62a56b279c98a11d0987096a01cc3eeb8eb7bbd7/index";

class YouTubeVideo extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        const { id, width, height } = this.props;
        const videoSrc = `//www.youtube.com/embed/${this.props.data.id}`;
        return (
            <div className="ratio ratio-16x9">
                <iframe src={videoSrc} width={this.props.data.width} height={this.props.data.height} />
            </div>
        );
    }
}

export default branch({}, YouTubeVideo);



// WEBPACK FOOTER //
// ./src/pages/components/page/YouTubeVideo.js